import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { isMasterByEmail, normalizeRole } from '@/modules/shared'
import AccessDeniedPage from '@/pages/AccessDenied'
import { useRevshareAllowed } from '../hooks/useRevshareAllowed'
import RepassesMasterView from '../components/RepassesMasterView'
import RepassesParticipantView from '../components/RepassesParticipantView'

export default function RepassesPage() {
  const { user, profile } = useAuth()
  const masterEmail = isMasterByEmail(user?.email)
  const effectiveRole = normalizeRole(
    profile?.role || (user as any)?.user_metadata?.role || (user as any)?.app_metadata?.role,
  )
  const isMaster = masterEmail || effectiveRole === 'master'
  const allowed = useRevshareAllowed()

  if (!isMaster && allowed === false) return <AccessDeniedPage />
  if (!isMaster && allowed == null) return <div className="p-4 text-sm text-foreground/70">Carregando...</div>

  return (
    <div className="mx-auto w-full max-w-[1550px] p-4">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">Repasses</h1>
        <p className="text-sm text-foreground/70">
          Controle de repasse mensal por percentual da receita liquida (apos taxa Stripe).
        </p>
      </div>

      {isMaster ? <RepassesMasterView /> : <RepassesParticipantView />}
    </div>
  )
}
